interface IMainPanelUsageEvents {
  root: string;
}

export const MainPanelUsageEvents: IMainPanelUsageEvents = {
  root: 'SPark.Registration.MainPanel',
};
